import { useReduxState } from 'hooks';
import { FormGroup, TextArea } from 'components/common/form';
import { MergedCompetency } from 'lib/competencies/getMergedCompetencies';
import { Box } from 'components/common/box';

interface Props {
  commentInitialValue?: string;
  competency: MergedCompetency;
}

const ProfileCompetenciesEndorsementsForm = ({
  commentInitialValue,
  competency
}: Props) => {
  const { messages, theme } = useReduxState();

  return (
    <div className="endorse-form">
      <div>
        <div className="label">{messages.competenciesEndorseCompetency}</div>
        <div className="title">{competency.name}</div>
        {competency.description && (
          <div className="description">{competency.description}</div>
        )}
      </div>

      <FormGroup
        htmlFor="comment"
        label={messages.commonComment}
        labelIsOptional={true}
        style={{ marginTop: 25 }}
        maxWidth="100%"
      >
        <TextArea
          autoGrow={true}
          field="comment"
          initialValue={commentInitialValue || ''}
          rows={3}
        />
      </FormGroup>

      <style jsx>{`
        .label {
          color: ${theme.textColorLighter};
          font-size: 1.3rem;
          font-weight: 600;
        }
        .title {
          font-size: 1.6rem;
          font-weight: 700;
          margin-top: 5px;
        }
        .description {
          margin-top: 5px;
          margin-bottom: 15px;
          color: ${theme.textColorLighter};
        }
      `}</style>
    </div>
  );
};

export default ProfileCompetenciesEndorsementsForm;
